import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Context } from "../../Shared/Context/GlobalContext";
import { CartListComponent } from "../Orderpage/components/CardItemComponent";
import { CreateCustomerFormComponent } from "./components/CreateCustomerFormComponent";
import routes from "../../Helpers/Routes.json";
import { useTranslation } from "react-i18next";

function CheckoutPage() {
  const { user, cartProducts } = useContext(Context);
  const { t } = useTranslation();

  return (
    <Container className="py-4" style={{ maxWidth: "800px" }}>
      <h1 className="h3 fw-bold mb-4 text-center">
        {t("Finalizar pedido")}
      </h1>
      <Row className="justify-content-center">
        <Col md={8}>
          {user ? (
            <div className="card p-4">
              <CartListComponent cartProducts={cartProducts} />
              <Link
                to={routes.Payment.index}
                className="btn btn-dark rounded-pill w-100 mt-3"
              >
                {t("Ir al Pago")}
              </Link>
            </div>
          ) : (
            <CreateCustomerFormComponent />
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default CheckoutPage;
